export default function AttachAgendaItemDocumentController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  oversightDataService,
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Document Added';
  vm.isExpanded = false;
  vm.loading = false;
  vm.canDownloadDocument = userService.getUserPermission('displayDOCDownloadDocumentLink');
  vm.canEditDocument = userService.getUserPermission('displayDOCEditDocumentLink');
  vm.canDeleteDocument = userService.getUserPermission('displayDOCDeleteDocumentLink');

  // Attach Event Handlers
  vm.handleAttachDocument = _handleAttachDocument;

  function _handleAttachDocument() {
    const dfdSave = $q.defer();

    if (vm.document.attached) {
      oversightDataService.attachAgendaItemDocument(vm.agendaItemId, vm.document.documentId).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while attaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been attached successfully.`);
          vm.document.agendaItemDocumentId = response.data.agendaItemDocumentId;
          $rootScope.$broadcast('refreshAgendaItemDocuments', { agendaItemId: vm.agendaItemId });
          $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
          dfdSave.resolve();
        }
      });
    } else {
      oversightDataService.detachAgendaItemDocument(vm.document.agendaItemDocumentId).then((response) => {
        if (!response.status === 200) {
          alerts.error('Error occurred while detaching the Document.');
          dfdSave.reject();
        } else {
          alerts.success(`Document ${vm.document.name} has been detached successfully.`);
          vm.document.agendaItemDocumentId = null;
          $rootScope.$broadcast('refreshAgendaItemDocuments', { agendaItemId: vm.agendaItemId });
          $rootScope.$broadcast('refreshAgendaItem', { agendaItemId: vm.agendaItemId });
          dfdSave.resolve();
        }
      });
    }
  }
}

AttachAgendaItemDocumentController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'oversightDataService'
];
